import Col from "components/ui-elements/Col";
import React from "react";
import Checkbox from "./Checkbox";
const CheckboxCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <Checkbox {...rest} margin={margin} />
    </Col>
  );
};

CheckboxCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-1"
}

export default CheckboxCol;